import React, {useEffect, useState, useRef} from "react";
import {Button, message, Card, Layout, Alert} from 'antd';
import {MDBAlert, MDBBtn, MDBIcon} from "mdbreact";
import Firebase from "../../../Firebase";
import {useListVals} from "react-firebase-hooks/database";
import {useAuthState} from "react-firebase-hooks/auth";
import FireFetch from "../../FireFetch";
import {Text} from "evergreen-ui";
import ScrollToBottom from 'react-scroll-to-bottom';

const { Header, Content } = Layout;


const userRef = Firebase.database().ref("System/Users");
const messageRef = Firebase.database().ref("System/Messages");
var moment = require("moment");
const Messages = (props) => {

    const divRef = useRef(null);
    const [users] = useListVals(userRef);
    const [messages, loading, error] = useListVals(messageRef);
    const [messageArray, setMessageArray] = useState([]);
    const [loggedInUser] = useAuthState(Firebase.auth());
    const [chatDetails, setChatDetails] = useState(props.chatDetails);
    
    useEffect(() => {
        //document.documentElement.scrollTop
        if (divRef) {
            divRef.current.addEventListener('DOMNodeInserted', event => {
                const { currentTarget: target } = event;
                target.scroll({ top: target.scrollHeight, behavior: 'smooth' });
            });
        }
        if(loggedInUser){
            setChatDetails(props.chatDetails);
        }
        
        if(messages){
            //messages.reverse();
            var array = messages.filter(x => ((x.sender === props.chatDetails.receiver || x.receiver === props.chatDetails.receiver)
                &&(x.sender === loggedInUser.uid || x.receiver === loggedInUser.uid)));

            array.sort((a, b) => {
                var dateA = moment(a.timeStamp, "YYYY-MM-DDTh:mm");
                var dateB = moment(b.timeStamp, "YYYY-MM-DDTh:mm");
                return moment(dateA).diff(dateB);
            });

            setMessageArray(array);

            var filterArray = array.filter(x => (x.status === "unread")&&(x.receiver === loggedInUser.uid));
            filterArray.map((item) => {

                FireFetch.updateInDB("Messages", item.messageID, {status : "read"}).then(() => {

                })
            })

        }

        
    }, [loggedInUser, messages, props.chatDetails]);

    const errorMessage = () => {
        message.error('Unable to send message');
    };
    const success = () => {
        message.success('Message Sent out!');
    };
    
    const sendMessage = () => {
        var message = document.getElementById("sendMess").value;
        var messageID =  Array(30).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789")
            .map(function(x) { return x[Math.floor(Math.random() * x.length)] }).join('');
        var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");

        if(message.length !== 0){
            var object = {
                message : message,
                chatID : chatDetails.chatID,
                messageID : messageID,
                sender : loggedInUser.uid,
                receiver : chatDetails.receiver,
                timeStamp : timeStamp,
                status : "unread"
            }

            FireFetch.SaveTODB("Messages", messageID, object).then((result) => {
                if(result === "success"){
                    document.getElementById("sendMess").value = "";
                    success();
                }
            }).catch((error) => {
                errorMessage();
            })
        }
    }

    return (

        <div className="h-100">
            <Layout className="h-100">
                <Header className="text-white d-flex align-items-center">
                    <MDBIcon icon="chevron-circle-left" className="mr-1" size="2x" onClick={() => {props.chatlist(false)}}/>
                    <h6 className="ml-4 text-white">{chatDetails.name}</h6>
                </Header>
                <Content>
                    <div ref={divRef} className="p-1 h-100 m-2 d-flex flex-column anotherScroll">
                        <ScrollToBottom>
                            {messageArray.map((content, index) => (
                                <span className={loggedInUser.uid === content.sender ? "w-75 p-2 rounded d-flex flex-column my-1 border border-primary" :
                                    "w-75 p-2 rounded d-flex flex-column my-1 float-right border border-success"}

                                >
                                <Text className= {loggedInUser.uid !== content.sender ? "float-right d-flex align-self-end" : null}>
                                    {content.message}
                                </Text>
                                <small className="text-muted float-right d-flex align-self-end">{moment(content.timeStamp, "YYYY-MM-DDTh:mm").format("DD MMM, hh:mm")}</small>
                            </span>
                            ))}
                        </ScrollToBottom>

                    </div>
                </Content>

                <div className="p-1 my-2 mx-1 d-flex flex-row align-items-center">
                    <input
                        type="text"
                        placeholder="enter your message"
                        className="form-control rounded-pill mr-1"
                        id="sendMess"
                    />
                    <MDBBtn color="primary" className="rounded-circle ml-1" onClick={() => {
                        sendMessage();
                    }}>
                        <MDBIcon icon="angle-right" className="m-1" />
                    </MDBBtn>
                </div>
            </Layout>
        </div>

    )
}

export default Messages;